import { Link } from "react-router-dom";

const stats = [
  { value: "12", label: "追踪赛事" },
  { value: "47", label: "异常时点" },
  { value: "6/12", label: "公开分钟级数据" },
];

export default function HeroSection() {
  return (
    <section className="relative min-h-[580px] md:min-h-[680px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Grand%20beauty%20pageant%20stage%20seen%20from%20the%20audience%2C%20empty%20runway%20with%20deep%20crimson%20curtains%20and%20warm%20gold%20spotlights%20crossing%20in%20haze%2C%20no%20people%2C%20stylized%20cinematic%20editorial%20photography%2C%20dramatic%20contrast%2C%20premium%20magazine%20aesthetic&width=1920&height=1080&seq=guaguan-hero-stage&orientation=landscape"
          alt="选美舞台上交错的金色追光与深红色帷幕"
          title="选美吃瓜投票打榜观察 - 瓜圈显微镜"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/90 via-foreground-950/70 to-foreground-950/40" />
      </div>

      <div className="relative w-full px-4 md:px-6 xl:px-10 pt-32 pb-16 md:pt-40 md:pb-24">
        <div className="max-w-[820px] animate-fade-up">
          <p className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50/12 border border-background-50/20 text-background-100 text-xs tracking-wider mb-6">
            <i className="ri-radar-line text-accent-400" />
            投票打榜 · 数据观察 · 不站队
          </p>

          <h1 className="font-heading text-3xl md:text-5xl xl:text-[3.4rem] leading-tight font-black text-background-50">
            选美吃瓜
            <span className="text-accent-400">，</span>
            先把票数看清楚
          </h1>

          <p className="mt-6 text-base md:text-lg leading-relaxed text-background-200 max-w-[680px]">
            决赛夜的票数为什么会在凌晨突然拉升？后援会的集资账目究竟怎么算？我们把选美
            <strong className="font-semibold text-background-50">投票打榜</strong>
            里的每一次异常增长、每一场粉丝内战、每一条计票规则，拆开来看。
          </p>

          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <Link
              to="/ranking"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md text-sm font-medium bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-book-open-line" />
              进入打榜观察
            </Link>
            <Link
              to="/article/midnight-vote-spike"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md text-sm font-medium bg-background-50/10 border border-background-50/30 text-background-50 hover:bg-background-50/20 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-play-circle-line" />
              阅读本期主打
            </Link>
          </div>

          <dl className="mt-12 flex flex-wrap items-center gap-x-10 gap-y-4">
            {stats.map((item) => (
              <div key={item.label} className="flex items-baseline gap-2">
                <dt className="sr-only">{item.label}</dt>
                <dd className="font-heading text-2xl md:text-3xl font-bold text-accent-400">{item.value}</dd>
                <dd className="text-xs md:text-sm text-background-300">{item.label}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
}